import React, { useState, useMemo, useEffect } from 'react';
import { Card, Row, Col, Button, Form, Badge, InputGroup, Modal } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faPlus,
    faSearch,
    faEdit,
    faTrash,
    faArchive,
} from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../../firebase/AuthProvider';
import { GetAllChannelAsync } from '../../../services/teamandregion/TeamandRegionService';
import { toast } from 'react-toastify';
import { GetChannelRes } from '../../../interfaces/team/TeamandRegion.modal';
import { CHANNEL_TYPE } from '../../../Data/SD';
import CreateCustomChannelModal from './modals/CreateCustomChannelModal';
import Loader from '../loader/Loader';
import SelectedChannelDetails from './SelectedChannelDetails';
import { UpdateArchivedStatusOfChannelAsync } from '../../../services/channelService/ChannelService';
import { UpdateArchivedStatusOfChannelReq } from '../../../interfaces/channelDtos/channelDtos';
import { showConfirmationDialog } from '../../modal/ConfimationModal/Confimation';
import ArchivedChannelModal from './modals/ArchivedChannelModal';

interface ChannelTabProps {
    // groups: Group[];
    // users: User[];
}

const ChannelTab: React.FC<ChannelTabProps> = () => {
    const { currentUser } = useAuth();

    // Data
    const [channels, setChannels] = useState<GetChannelRes[]>([]);
    const [selectedChannel, setSelectedChannel] = useState<GetChannelRes | null>(null);
    const [selectedChannelForEdit, setSelectedChannelForEdit] = useState<GetChannelRes>();

    // Others
    const [loading, setLoading] = useState<boolean>(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [typeFilter, setTypeFilter] = useState('all');
    const [showCreateChannelModal, setShowCreateChannelModal] = useState<boolean>(false);
    const [showArchivedChannelModal, setShowArchivedChannelModal] = useState<boolean>(false);

    const [archivedChannelRefreshKey, setArchivedChannelRefreshKey] = useState<number>(0);


    useEffect(() => {
        getAllChannel();
    }, [currentUser]);

    const getAllChannel = async () => {
        const token = await currentUser?.getIdToken();
        if (!token) return;

        setLoading(true);
        GetAllChannelAsync(token).then((res) => {
            if (res.success) {
                setChannels(res.data);
            } else {
                toast.error(res.message);
            }
        }).catch((err) => {
            toast.error(err.message);
        }).finally(() => {
            setLoading(false);
        })
    }


    const handleCloseCreateChannelModal = () => {
        setSelectedChannelForEdit(undefined);
        setShowCreateChannelModal(false);
    }
    const handleShowCreateChannelModal = () => setShowCreateChannelModal(true);

    const handleCloseArchivedChannelModal = () => setShowArchivedChannelModal(false);

    const handleShowArchivedChannelModal = () => setShowArchivedChannelModal(true);

    // const selectedGroupData = useMemo(() => {
    //     if (!selectedGroup) return null;
    //     return groups.find(group => group.id === selectedGroup);
    // }, [selectedGroup, groups]);

    // const groupMembers = useMemo(() => {
    //     if (!selectedGroupData) return [];
    //     return users.filter(user => selectedGroupData.members.includes(user.id));
    // }, [selectedGroupData, users]);

    const getGroupTypeVariant = (type: string) => {
        const variants = {
            COMPANY: 'primary',
            TEAM: 'success',
            CUSTOM: 'info'
        };
        return variants[type as keyof typeof variants] || 'secondary';
    };

    const formatGroupType = (type: string) => {
        return type.charAt(0).toUpperCase() + type.slice(1).replace('-', ' ');
    };


    const handleEditChannel = (e: React.MouseEvent<HTMLButtonElement>, channel: GetChannelRes) => {
        e.stopPropagation();
        setSelectedChannelForEdit(channel);
        handleShowCreateChannelModal();
    }

    const updateArchivedStatusOfChannel = async (chanelId: string, status: boolean) => {
        const isConfirm = await showConfirmationDialog(
            undefined, // keep default title
            `Do you really want to ${status ? "archive this channel?" : "Remove from archive List?"} ` // override only text
        );

        if (!isConfirm || !currentUser) return;
        const payload: UpdateArchivedStatusOfChannelReq = {
            channelId: chanelId,
            isArchived: status
        }
        const token = await currentUser.getIdToken();
        UpdateArchivedStatusOfChannelAsync(payload, token).then((res) => {
            if (res.success) {
                getAllChannel();
                setArchivedChannelRefreshKey(archivedChannelRefreshKey + 1);
            } else {
                toast.error(res.message);
            }
        }).catch((err) => {
            toast.error(err.message);
        })
    }


    return (
        <>
            {loading && <Loader />}
            {selectedChannel ? (
                <SelectedChannelDetails
                    selectedChannel={selectedChannel}
                    setSelectedChannel={setSelectedChannel}
                    handleEditChannel={handleEditChannel}
                />
            ) : (
                <div>
                    {/* Header */}
                    <div className="">
                        <div className='top border_tittle top_bar_flx'>
                            <div className='top_bar_tittle '>
                                <h2 className="mb-0">Channel Management</h2>
                                <p>Manage organization, team, and custom Channels</p>
                            </div>
                            <div className='top_right_flx'>
                                <Button variant="secondary" className='btn_sm' onClick={handleShowArchivedChannelModal}>Show Archived Channel</Button>
                                <Button variant="primary" className='btn_sm' onClick={handleShowCreateChannelModal}>Create Custom Channel</Button>
                            </div>
                        </div>
                    </div>

                    {/* Filters */}
                    {/* <Card className="mb-4">
                        <Card.Body>
                            <Row>
                                <Col lg={8}>
                                    <InputGroup>
                                        <InputGroup.Text>
                                            <FontAwesomeIcon icon={faSearch} size="sm" />
                                        </InputGroup.Text>
                                        <Form.Control
                                            type="text"
                                            placeholder="Search groups..."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </InputGroup>
                                </Col>
                                <Col lg={4}>
                                    <Form.Select
                                        value={typeFilter}
                                        onChange={(e) => setTypeFilter(e.target.value)}
                                    >
                                        <option value="all">All Types</option>
                                        <option value="organization">Organization</option>
                                        <option value="team">Team</option>
                                        <option value="custom">Custom</option>
                                    </Form.Select>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card> */}

                    {/* Groups Grid */}
                    <Row>
                        {channels.map((channel, index) => {
                            // const createdBy = users.find(user => user.id === group.createdBy);
                            return (
                                <div key={index} className="col-sm-12 col-md-6 col-lg-6 col-xl-4 mb-4">
                                    <div className="common_card h-100" style={{ cursor: 'pointer' }} onClick={() => setSelectedChannel(channel)}>
                                        <div className="top top_bar_flx border_tittle">
                                            <div className='top_bar_tittle sm_tittle'>
                                                <h2>{channel.channelName}</h2>
                                            </div>
                                            <div className="top_right_flx">
                                                <div className="my_badge">
                                                    <Badge bg={getGroupTypeVariant(channel.channelType)}>{formatGroupType(channel.channelType)}</Badge>
                                                </div>
                                            </div>
                                        </div>
                                        {/* {group.description && (
                                            <Card.Text className="text-muted small mb-3">{group.description}</Card.Text>
                                        )} */}
                                        <div className="mb-3">
                                            <div className="stats_list mby_16">
                                                <div className='stats d-flex align-items-center justify-content-between gap-2'>
                                                    <h3>Members</h3>
                                                    <p>{channel.memberCount}</p>
                                                </div>
                                                <div className='stats d-flex align-items-center justify-content-between gap-2'>
                                                    <h3>Created by</h3>
                                                    <p> {channel.createdBy.displayName || 'Unknown'}</p>
                                                </div>
                                                <div className='stats d-flex align-items-center justify-content-between gap-2'>
                                                    <h3>Created</h3>
                                                    <p> {new Date(channel.created).toLocaleDateString()}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-end">
                                            <div className="top_bar_tittle sm_tittle">
                                                <Button variant='primary' className='btn_sm'>View details</Button>
                                            </div>
                                        </div>
                                        {channel.channelType == CHANNEL_TYPE.CUSTOM.toString() && (
                                            <div className="d-flex gap-1">
                                                <Button
                                                    variant="outline-primary"
                                                    size="sm"
                                                    title='Edit'
                                                    onClick={(e) => handleEditChannel(e, channel)}
                                                >
                                                    <FontAwesomeIcon icon={faEdit} size="xs" />
                                                </Button>
                                                <Button
                                                    variant="outline-secondary"
                                                    size="sm"
                                                    title='Archive'
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        updateArchivedStatusOfChannel(channel.channelId, true);
                                                    }}
                                                >

                                                    <FontAwesomeIcon icon={faArchive} size='xs' />
                                                </Button>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </Row>

                </div>
            )}

            {/* Always render the modal at the root */}
            {showCreateChannelModal && (
                <CreateCustomChannelModal
                    handleCloseCreateChannelModal={handleCloseCreateChannelModal}
                    showCreateChannelModal={showCreateChannelModal}
                    refreshChannelList={getAllChannel}
                    SelectedChannelForEdit={selectedChannelForEdit}
                />
            )}

            {showArchivedChannelModal && (
                <ArchivedChannelModal
                    handleCloseChannelModal={handleCloseArchivedChannelModal}
                    showChannelModal={showArchivedChannelModal}
                    updateArchivedStatusOfChannel={updateArchivedStatusOfChannel}
                    archivedChannelRefreshKey={archivedChannelRefreshKey}
                />
            )}
        </>
    );
};

export default ChannelTab;